// extracted by mini-css-extract-plugin
export var actions = "_7z-8";
export var arrow = "_7z-5";
export var card = "_7z-0";
export var cardWrapper = "_7z-9";
export var fieldName = "_7z-3";
export var newValue = "_7z-6";
export var oldValue = "_7z-4";
export var orangeGlowFade = "_7z-c";
export var productSection = "_7z-1";
export var scrollToBottom = "_7z-b";
export var scrollToBottomAnchor = "_7z-a";
export var scrollToBottomIcon = "_7z-d";
export var showAllButton = "_7z-7";
export var table = "_7z-2";